import { createImageBlock } from "./blocks/image";
import { createTemplateSocialBlock } from "./blocks/social";
import { createTextBlock, TEXT_PLACEHOLDERS } from "./blocks/text";
import { createRow } from "./factories";
import { wrapMergeTag } from "./merge-tags";
import type { Row, TextBlock } from "./types";

export function createBlankTemplateHeaderRow(): Row {
  const logo = createImageBlock();
  logo.media = { kind: 'facility', assetKey: 'logo' };
  logo.facilityLogoSizing = 'header';
  logo.alt = wrapMergeTag('facility.long_name');
  logo.align = 'center';

  const row = createRow('one', [[logo]], { contentGutter: false });
  row.backgroundColor = 'transparent';
  return row;
}

export const TEMPLATE_FOOTER_SOCIAL_SECTION_ID =
  's2222222-2222-4222-8222-222222222222';

export function createTemplateFooterSocialRow(): Row {
  const social = createTemplateSocialBlock();
  const row = createRow('one', [[social]], { contentGutter: false });
  row.id = TEMPLATE_FOOTER_SOCIAL_SECTION_ID;
  row.backgroundColor = 'transparent';
  return row;
}

export function createBlankTemplateFooterRow(): Row {
  const footer = createTextBlock(
    'normal',
    `${wrapMergeTag('facility.address_line_1')}<br/>${wrapMergeTag('facility.city')}, ${wrapMergeTag('facility.province_code')} ${wrapMergeTag('facility.postal')}<br/>${wrapMergeTag('facility.phone')}<br/><a href="${wrapMergeTag('client.website_url')}">${wrapMergeTag('client.website_url')}</a><br/><a href="${wrapMergeTag('customer.unsubscribe_url')}">Unsubscribe</a>`,
  );
  footer.align = 'center';
  footer.fontSize = 14;
  footer.padding = { top: 0, right: 0, bottom: 0, left: 0 };

  const row = createRow('one', [[footer]], { contentGutter: false });
  row.backgroundColor = 'transparent';
  return row;
}

export function isDefaultTextHtml(block: TextBlock): boolean {
  const plain = block.html.replace(/<[^>]+>/g, '').trim();
  return (
    block.html === TEXT_PLACEHOLDERS[block.variant] ||
    plain === TEXT_PLACEHOLDERS[block.variant]
  );
}
